<template>
  <div class="listmain ">
      <h1 class="firTitle">返回参数说明</h1>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
           API 以及相关 SDK 请求接口返回参数的说明。
          </span>
      </p>

 <h3 class="sedTitle">登录返回参数说明</h3>
      <highlight-code lang="javascript">
<span>
    data = {
    controlSpeakerDeviceId = ""; //当前音箱设备ID
    controlSpeakerId = 0; //当前音箱ID
    mobileDeviceId = "C0975C13-03CE-4149-8B04-4F94B729E497"; //手机设备id
    mobileId = 2584; //手机id
};
</span>
      </highlight-code>

      <h3 class="sedTitle">设备管理返回参数说明</h3>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9"> 获取设备列表</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "7e34ed7a-7f85-4dfd-918b-0a7feb6b4818",
              "code": "200",
              "text": "none",
              "domain": "用户",
              "english_domain": "BizUser",
              "intent": "speakerList",
              "data": [
                  {
                      "speakerId": "20495",//音箱ID
                      "speakerDeviceId": "XY762003B7",//音箱设备ID
                      "speakerAndroidId": "b4450ebd3432527f",//音响安卓ID
                      "name": "rk3188",//设备名称
                      "version": "1.6.54",//应用版本号
                      "model": "XiaoYa",//设备型号
                      "sn": "XY762003B7",//序列号
                      "ssid": "\"ChinaNet-jvmf\"",//设备连接的SSID
                      "imei": "012345678912345",//IMEI
                      "osVersion": "1.1.25"//系统版本
                  }
              ]
          }
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">设备状态</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "fb9034a4-1493-4de4-b4c2-1bd2cfe7a997",
              "code": "200",
              "text": "none",
              "domain": "用户",
              "english_domain": "BizSpeaker",
              "intent": "getStatus",
              "data": {
                  "tip": "音箱离线",
                  "onlineStatus": "0",//1为在线，0为离线
                  "networkStatus": "0",//网络状态 0：无网络 1：有网络
                  "volumeStatus": "0",//声音状态 0：静音 1-100 具体大小
                  "bluetoothStatus": "0",//蓝牙状态 0：关闭 1：只是打开但闲置 2:蓝牙打开处于播放状态
                  "micStatus": "1",//禁麦状态 0：已禁麦 1：未禁麦
              }
          }
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">设备信息</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "2a135338-307c-4d83-903c-de91a2037205",
              "code": "200",
              "text": "none",
              "domain": "音箱",
              "english_domain": "BizSpeaker",
              "intent": "getInfo",
              "data": {
                  "speakerId": "1049",//音箱ID
                  "speakerDeviceId": "wt-device-id",//音箱设备ID
                  "speakerAndroidId": "",//音响安卓ID
                  "name": "小雅音响",//音箱名称
                  "version": "2",//应用版本号
                  "model": "box",//设备型号
                  "sn": "AVRZX0D11V",//序列号
                  "ssid": "\"MERCURY_D572\"",//设备连接的SSID
                  "imei": null,//IMEI
                  "osVersion": "19",//系统版本
              }
          }

      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">设备更新</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "e8f3e9bf-e01d-4fd3-b348-1792d10f27ec",
              "code": "200",
              "text": "none",
              "domain": "音箱",
              "english_domain": "BizSpeaker",
              "intent": "updateInfo",
              "data": null
          }
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">设备解绑</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "1d345b08-5d6b-4001-bff4-d8ba4e0bbda2",
              "code": "200",
              "text": "none",
              "domain": "用户",
              "english_domain": "BizUser",
              "intent": "mobileDelete",
              "data": null
          }
      </highlight-code>
      <h3 class="sedTitle">信息流返回参数说明</h3>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">信息流历史记录</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "1ad8da53-ea77-4070-94ba-4c7079f87622",
              "code": "200",
              "text": "none",
              "domain": "用户",
              "english_domain": "BizUser",
              "intent": "queryHistory",
              "data": {
                  "count": 10,//取得的数量
                  "timeline": 1501487171,//起始时间戳
                  "more": true,//是否还有更多
                  "items": [
                      {
                          "historyId": "260",//历史id
                          "sessionId": "e16797b4-97bf-44f2-bb38-3a5f4bd44ad3",//sid
                          "createDt": 1501484334,//创建时间戳
                          "request": {},//请求详情
                          "response": {},//响应详情
                          "card": {}, //卡片
                          "version": 1,//版本
                      },
                      {...},
                  ]
              }
          }
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">信息流反馈</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "f77996ca-c625-4f63-a4d4-79400cae6a3d",
              "code": "200",
              "text": "none",
              "domain": "用户",
              "english_domain": "BizUser",
              "intent": "feedbackHistory",
              "data": null
          }
      </highlight-code>
      <h3 class="sedTitle">技能商店返回参数说明</h3>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">技能商店列表</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "60726f1d-61e9-412d-bbdd-7334adbb8f89",
              "code": "200",
              "text": "none",
              "domain": "用户",
              "english_domain": "BizApp",
              "intent": "skillsList",
              "data": [
                  {
                      "category_name": "有声内容",//分类名称
                      "data": [
                          {
                              "skill_id": "19",//技能ID
                              "skill_name": "喜马拉雅",//技能名称
                              "skill_tts_answer": "小雅小雅，我想听相声",//技能发问方式
                              "skill_icon_url": "http://10.52.66.103:8082/speaker/pic/0a7f0e416bfb160a86e7d7152c6b1f55.png",//技能Icon图标
                              "skill_type": 1//指令词类型：1 文本, 6 闹钟 等,
                          },
                          {...},
                      ]
                  },
              ]
          }
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">技能商店详情</span>
      </p>
      <highlight-code lang="javascript">
          {
              "sid": "5c03b5b7-db43-4a49-b6ae-4aaf36a7c720",
              "code": "200",
              "text": "none",
              "domain": "用户",
              "english_domain": "BizApp",
              "intent": "skillsListDetail",
              "data": [
                  {
                      "skill_name": "喜马拉雅",
                      "skill_tts_answer": "小雅小雅，我想听相声",
                      "skill_intro": "小雅拥有海量...",
                      "skill_icon_url": "http://10.52.66.103:8082/speaker/pic/0a7f0e416bfb160a86e7d7152c6b1f55.png",
                      "order_words": [
                          "“⼩雅⼩雅，我想听相声”",
                      ],
                      "skill_sh_company": "",
                      "skill_type": 1,
                      "category_name": "有声内容",
                      "order_words_all": []
                  }
              ]
          }
      </highlight-code>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Parameter.vue